import * as Sentry from '@sentry/vue';
import Cookies from 'js-cookie';

const state = () => ({});

// getters
const getters = {};

// actions
const actions = {
  login(context, creds) {
    return new Promise((resolve) => {
      setTimeout(() => {
        localStorage.setItem('session', creds.session);
        localStorage.setItem('first_name', creds.first_name);
        localStorage.setItem('last_name', creds.last_name);
        localStorage.setItem('email', creds.email);
        localStorage.setItem('profile_picture', creds.profile_picture);
        localStorage.setItem('authorized_products', creds.authorized_products);
        // this._vm.$socket.emit('clientSessionToken', { data: creds.session });
        resolve();
      }, 1000);
    });
  },
  logout() {
    localStorage.removeItem('session');
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('email');
    localStorage.removeItem('profile_picture');
    localStorage.removeItem('authorized_products');
    localStorage.removeItem('product_type');
    Cookies.remove('site_version');
    Cookies.remove('hirefly_user', {
      path: '',
      domain: '.hirefly.ai',
    });
    Sentry.setUser(null);
  },
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
